export default __webpack_public_path__ + "static/media/02.14b7fecd.png";